export enum PlaceType {
  ORIGIN = 'ORIGIN',
  DESTINATION = 'DESTINATION',
}
